export default function TandCsIcon({ svgClass }) {
  return (
    <svg
      className={svgClass}
      id='Layer_2'
      data-name='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 40.17 53.08'>
      <defs></defs>
      <g id='Layer_3' data-name='Layer 3'>
        <g>
          <path
            className='cls-1'
            d='M34.24,14.29h5.91L25.85,0h-.04V5.86c0,4.65,3.78,8.43,8.43,8.43Z'
            fill='#ffff8b'
          />
          <path
            className='cls-1'
            d='M34.24,18.04c-6.71,0-12.18-5.46-12.18-12.18V0H7.64C3.42,0,0,3.42,0,7.64V45.44c0,4.22,3.42,7.64,7.64,7.64h24.89c4.22,0,7.64-3.42,7.64-7.64V18.04h-5.93ZM4.86,24.39c0-1.03,.84-1.87,1.87-1.87h11.65c1.03,0,1.87,.84,1.87,1.87h0c0,1.03-.84,1.87-1.87,1.87H6.72c-1.03,0-1.87-.84-1.87-1.87h0Zm26.88,19.1H6.72c-1.03,0-1.87-.84-1.87-1.87s.84-1.87,1.87-1.87H31.73c1.03,0,1.87,.84,1.87,1.87s-.84,1.87-1.87,1.87Zm0-8.64H6.72c-1.03,0-1.87-.84-1.87-1.87s.84-1.87,1.87-1.87H31.73c1.03,0,1.87,.84,1.87,1.87s-.84,1.87-1.87,1.87Z'
            fill='#ffff8b'
          />
        </g>
      </g>
    </svg>
  );
}
